import appChargeLogo from '@/assets/icons/common/appcharge.svg';
import { useTranslate } from '@/hooks/useTranslate';

export const PoweredByAppcharge = () => {
  const { t } = useTranslate();

  return (
    <div className="flex items-center justify-center gap-2 h-10">
      <div className="text-[10px] text-base-black">{t('poweredBy')}</div>
      <img src={appChargeLogo} alt="appcharge" className="w-[119px] h-8" />
    </div>
  );
};
